var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, width: "600", persistent: "" } },
    [
      _c(
        "v-card",
        { attrs: { color: "fill" } },
        [
          _c(
            "v-card-title",
            { class: _vm.title },
            [
              _c("span", [_vm._v("Copy / Move Ad Feature")]),
              _c(
                "v-col",
                {
                  staticClass: "ml-auto my-auto py-0 pr-0 d-inline-flex",
                  attrs: { cols: "auto" },
                },
                [
                  _c("p", { staticClass: "pa-0 my-auto mr-2 text-overline" }, [
                    _vm._v(" Action: "),
                  ]),
                  _c(
                    "v-btn-toggle",
                    {
                      attrs: { dense: "", color: "primary", mandatory: "" },
                      on: { change: _vm.getAds },
                      model: {
                        value: _vm.action,
                        callback: function ($$v) {
                          _vm.action = $$v
                        },
                        expression: "action",
                      },
                    },
                    [
                      _c("v-btn", { attrs: { value: "copy" } }, [
                        _vm._v("Copy"),
                      ]),
                      _c("v-btn", { attrs: { value: "move" } }, [
                        _vm._v("Move"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-container",
            { staticClass: "ma-0 pa-0 pt-6 px-6", attrs: { fluid: "" } },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            class: _vm.body,
                            attrs: {
                              label: "Destination Ad",
                              items: _vm.ads,
                              disabled: _vm.loading || _vm.noValidAds,
                              loading: _vm.loadingAds,
                              "item-text": "ad_name",
                              "item-value": "id",
                              "background-color": "input",
                              "menu-props": { maxHeight: 220, rounded: "" },
                              outlined: "",
                              dense: "",
                              "return-object": "",
                            },
                            on: { change: _vm.getFeaturePositions },
                            scopedSlots: _vm._u([
                              {
                                key: "item",
                                fn: function ({ item, on, attrs }) {
                                  return [
                                    _c(
                                      "v-list-item",
                                      _vm._g(
                                        _vm._b(
                                          { attrs: { dense: "" } },
                                          "v-list-item",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                " " + _vm._s(item.ad_name) + " "
                                              ),
                                            ]),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.ad_group_name) +
                                                  " "
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.destinationAd,
                              callback: function ($$v) {
                                _vm.destinationAd = $$v
                              },
                              expression: "destinationAd",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    {
                      attrs: { justify: "center", align: "center", dense: "" },
                    },
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            class: _vm.body,
                            attrs: {
                              label: "Destination Page",
                              items: _vm.pages,
                              disabled: _vm.loading || _vm.noValidAds,
                              "item-text": "name",
                              "item-value": "id",
                              "background-color": "input",
                              autocomplete: "off",
                              outlined: "",
                              dense: "",
                              "return-object": "",
                              "menu-props": { maxHeight: 220, rounded: "" },
                            },
                            on: { change: _vm.getFeaturePositions },
                            model: {
                              value: _vm.destinationPage,
                              callback: function ($$v) {
                                _vm.destinationPage = $$v
                              },
                              expression: "destinationPage",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c("v-autocomplete", {
                            class: _vm.body,
                            attrs: {
                              label: "Destination Position",
                              items: _vm.featurePositions,
                              disabled: _vm.loading || _vm.noValidAds,
                              loading: _vm.loadingFeaturePositions,
                              "item-text": "name",
                              "item-value": "id",
                              "background-color": "input",
                              autocomplete: "off",
                              outlined: "",
                              dense: "",
                              "return-object": "",
                              "menu-props": { maxHeight: 220, rounded: "" },
                            },
                            model: {
                              value: _vm.destinationFeaturePosition,
                              callback: function ($$v) {
                                _vm.destinationFeaturePosition = $$v
                              },
                              expression: "destinationFeaturePosition",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-toolbar",
            { attrs: { flat: "", color: "fill" } },
            [
              _c("v-col", { attrs: { cols: "auto" } }, [
                _vm.noValidAds
                  ? _c(
                      "span",
                      { staticClass: "warning--text" },
                      [
                        _c("v-icon", { attrs: { color: "warning" } }, [
                          _vm._v("mdi-alert-circle-outline"),
                        ]),
                        _vm._v(" No valid feature destinations found "),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  class: _vm.body,
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("update:value", false)
                    },
                  },
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "white--text ml-2",
                  class: _vm.body,
                  attrs: {
                    disabled: _vm.moveCopyDisabled,
                    color: _vm.action === "move" ? "warning" : "save",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.openConfirmDialog.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.selectedAction.text) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.confirmDialog
        ? _c("FeatureMoveDialog", {
            attrs: {
              move: _vm.action === "move",
              destinationAd: _vm.destinationAd,
            },
            on: {
              cancel: _vm.closeConfirmDialog,
              confirmAction: _vm.confirmAction,
            },
            model: {
              value: _vm.confirmDialog,
              callback: function ($$v) {
                _vm.confirmDialog = $$v
              },
              expression: "confirmDialog",
            },
          })
        : _vm._e(),
      _vm.warningsModal
        ? _c("FeaturePromoWarnings", {
            attrs: {
              selectedAd: _vm.selectedAd,
              gappedPromos: _vm.gappedPromos,
              move: _vm.action === "move",
            },
            on: {
              cancel: _vm.closeWarningsModal,
              confirmAction: _vm.confirmAction,
            },
            model: {
              value: _vm.warningsModal,
              callback: function ($$v) {
                _vm.warningsModal = $$v
              },
              expression: "warningsModal",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }